import React, { useState, useEffect } from 'react'
import { Drawer, IconButton, List } from '@material-ui/core'
import {
  Person as PersonIcon,
  Group as GroupIcon,
  FilterNone as UIElementsIcon,
  Queue as QueueIcon,
  LibraryBooks as LibraryIcon,
  LocalActivity as ActivityIcon,
  Settings as SettingsIcon,
  Flag as FlagIcon,
  Pages as PagesIcon,
  Bookmarks as BookmarksIcon,
  Category as CategoryIcon,
  TouchApp as TouchAppIcon,
  PostAdd as PostAddIcon,
  Equalizer as EqualizerIcon,
  Backup as BackupIcon,
  ArrowForward as ArrowForwardIcon,
  Public as PublicIcon,
  LocalOffer as LocalOfferIcon,
  MonetizationOn as MonetizationIcon
} from '@material-ui/icons'
import { useTheme } from '@material-ui/styles'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
// styles
import useStyles from './styles'

// components
import SidebarLink from './components/SidebarLink/SidebarLink'

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar
} from '../../../context/LayoutContext'
import { FormattedMessage } from 'react-intl'
import { NamedRoutes } from '../../../routes'


function Sidebar ({ location, adminSectionType }) {
  let classes = useStyles()
  const workspaceStructure = [
    {
      id: 0,
      label: <FormattedMessage id='Sidebar.Links.Users'/>,
      link: NamedRoutes.workspace.user.list,
      icon: <PersonIcon/>
    },
    {
      id: 5,
      label: <FormattedMessage id='Sidebar.Links.Companies'/>,
      link: NamedRoutes.workspace.company.list,
      icon: <BookmarksIcon/>
    },
    {
      id: 10,
      label: <FormattedMessage id='PaymentsContent.ActionLinks.Payments'/>,
      link: NamedRoutes.workspace.payments,
      icon: <QueueIcon/>
    },
    {
      id: 15,
      label: <FormattedMessage id='PaymentsContent.ActionLinks.PaymentRequests'/>,
      link: NamedRoutes.workspace.paymentRequests,
      icon: <UIElementsIcon/>
    },
    {
      id: 20,
      label: <FormattedMessage id='PaymentsContent.ActionLinks.PaymentReceipts'/>,
      link: NamedRoutes.workspace.paymentReceipts,
      icon: <LibraryIcon/>
    },
    {
      id: 22,
      label: <FormattedMessage id='Sidebar.Links.Currencies'/>,
      link: NamedRoutes.workspace.currencies.list,
      icon: <MonetizationIcon/>
    },
    { id: 25, type: 'divider' },
    {
      id: 30,
      label: <FormattedMessage id='Sidebar.Links.Pages'/>,
      link: NamedRoutes.workspace.page.list,
      icon: <PagesIcon/>
    },
    {
      id: 35,
      label: <FormattedMessage id='Sidebar.Links.Settings'/>,
      link: NamedRoutes.workspace.settings,
      icon: <SettingsIcon/>
    },
    {
      id: 40,
      label: <FormattedMessage id='Sidebar.Links.ActivityLog'/>,
      link: NamedRoutes.workspace.ActivityLog,
      icon: <ActivityIcon/>
    },
    {
      id: 45,
      label: <FormattedMessage id='Sidebar.Links.RolesAndPermissions'/>,
      link: NamedRoutes.workspace.RolesAndPermissions.list,
      icon: <FlagIcon/>
    },
    {
      id: 50,
      label: <FormattedMessage id='Sidebar.Links.uptcp'/>,
      link: NamedRoutes.workspace.uptcp,
      wrap: true,
      icon: <BackupIcon/>
    }
    // {
    //   id: 3,
    //   label: 'Typography',
    //   link: '/typography',
    //   icon: <TypographyIcon/>
    // },
    // { id: 4, label: 'Tables', link: '/tables', icon: <TableIcon/> },
    // {
    //   id: 5,
    //   label: 'Notifications',
    //   link: '/notifications',
    //   icon: <NotificationsIcon/>
    // },
    // {
    //   id: 6,
    //   label: 'UI Elements',
    //   link: '/ui',
    //   icon: <UIElementsIcon/>,
    //   children: [
    //     { label: 'Icons', link: '/icons' },
    //     { label: 'Charts', link: '/charts' },
    //     { label: 'Maps', link: '/maps' }
    //   ]
    // },
    // { id: 7, type: 'divider' },
    // { id: 8, type: 'title', label: 'HELP' },
    // { id: 9, label: 'Library', link: '', icon: <LibraryIcon/> },
    // { id: 10, label: 'Support', link: '', icon: <SupportIcon/> },
    // { id: 11, label: 'FAQ', link: '', icon: <FAQIcon/> },
    // { id: 12, type: 'divider' },
    // { id: 13, type: 'title', label: 'PROJECTS' },
    // {
    //   id: 14,
    //   label: 'My recent',
    //   link: '',
    //   icon: <Dot size="small" color="warning"/>
    // },
    // {
    //   id: 15,
    //   label: 'Starred',
    //   link: '',
    //   icon: <Dot size="small" color="primary"/>
    // },
    // {
    //   id: 16,
    //   label: 'Background',
    //   link: '',
    //   icon: <Dot size="small" color="secondary"/>
    // }
  ]
  const SubscriptionStructure = [
    {
      id: 0,
      label: <FormattedMessage id='Sidebar.Links.Users'/>,
      link: NamedRoutes.subscription.user.list,
      icon: <PersonIcon/>
    },
    {
      id: 2,
      label: <FormattedMessage id='Sidebar.Links.UserGroups'/>,
      link: NamedRoutes.subscription.userGroups.list,
      icon: <GroupIcon/>
    },
    {
      id: 3,
      label: <FormattedMessage id='Sidebar.Links.ExternalEntityGroups'/>,
      link: NamedRoutes.subscription.externalEntityGroups.list,
      icon: <PublicIcon/>
    },
    {
      id: 5,
      label: <FormattedMessage id='Sidebar.Links.Categories'/>,
      link: NamedRoutes.subscription.category.list,
      icon: <CategoryIcon/>
    },
    {
      id: 10,
      label: <FormattedMessage id='Sidebar.Links.Services'/>,
      link: NamedRoutes.subscription.service.list,
      icon: <TouchAppIcon/>
    },
    {
      id: 15,
      label: <FormattedMessage id='Sidebar.Links.Plans'/>,
      link: NamedRoutes.subscription.plan.list,
      icon: <PostAddIcon/>
    },
    {
      id: 17,
      label: <FormattedMessage id='Sidebar.Links.Promocodes' />,
      link: NamedRoutes.subscription.promocodes.list,
      icon: <LocalOfferIcon />
    },
    {
      id: 20,
      label: <FormattedMessage id='PaymentsContent.ActionLinks.PaymentRequests'/>,
      link: NamedRoutes.subscription.paymentRequests,
      icon: <UIElementsIcon/>
    },
    {
      id: 25,
      label: <FormattedMessage id='PaymentsContent.ActionLinks.PaymentReceipts'/>,
      link: NamedRoutes.subscription.paymentReceipts,
      icon: <LibraryIcon/>
    },
    {
      id: 30,
      label: <FormattedMessage id='Sidebar.Links.Reports'/>,
      link: NamedRoutes.subscription.report.home,
      icon: <EqualizerIcon/>,
      children: [
        {
          label: <FormattedMessage id='Sidebar.Links.Plans'/>,
          link: NamedRoutes.subscription.report.plans,
          icon: <PostAddIcon/>
        },
        {
          label: <FormattedMessage id='Sidebar.Links.Services'/>,
          link: NamedRoutes.subscription.report.services,
          icon: <TouchAppIcon/>
        },
        {
          label: <FormattedMessage id='Sidebar.Links.Subscriptions'/>,
          link: NamedRoutes.subscription.report.subscriptions,
          icon: <PersonIcon/>
        }
      ]
    },
    { id: 35, type: 'divider' },
    {
      id: 40,
      label: <FormattedMessage id='Sidebar.Links.Pages'/>,
      link: NamedRoutes.subscription.page.list,
      icon: <PagesIcon/>
    },
    {
      id: 45,
      label: <FormattedMessage id='Sidebar.Links.Settings'/>,
      link: NamedRoutes.subscription.settings,
      icon: <SettingsIcon/>
    },
    {
      id: 50,
      label: <FormattedMessage id='Sidebar.Links.ActivityLog'/>,
      link: NamedRoutes.subscription.ActivityLog,
      icon: <ActivityIcon/>
    },
    {
      id: 55,
      label: <FormattedMessage id='Sidebar.Links.RolesAndPermissions'/>,
      link: NamedRoutes.subscription.RolesAndPermissions.list,
      icon: <FlagIcon/>
    }
    // {
    //   id: 3,
    //   label: 'Typography',
    //   link: '/typography',
    //   icon: <TypographyIcon/>
    // },
    // { id: 4, label: 'Tables', link: '/tables', icon: <TableIcon/> },
    // {
    //   id: 5,
    //   label: 'Notifications',
    //   link: '/notifications',
    //   icon: <NotificationsIcon/>
    // },
    // {
    //   id: 6,
    //   label: 'UI Elements',
    //   link: '/ui',
    //   icon: <UIElementsIcon/>,
    //   children: [
    //     { label: 'Icons', link: '/icons' },
    //     { label: 'Charts', link: '/charts' },
    //     { label: 'Maps', link: '/maps' }
    //   ]
    // },
    // { id: 7, type: 'divider' },
    // { id: 8, type: 'title', label: 'HELP' },
    // { id: 9, label: 'Library', link: '', icon: <LibraryIcon/> },
    // { id: 10, label: 'Support', link: '', icon: <SupportIcon/> },
    // { id: 11, label: 'FAQ', link: '', icon: <FAQIcon/> },
    // { id: 12, type: 'divider' },
    // { id: 13, type: 'title', label: 'PROJECTS' },
    // {
    //   id: 14,
    //   label: 'My recent',
    //   link: '',
    //   icon: <Dot size="small" color="warning"/>
    // },
    // {
    //   id: 15,
    //   label: 'Starred',
    //   link: '',
    //   icon: <Dot size="small" color="primary"/>
    // },
    // {
    //   id: 16,
    //   label: 'Background',
    //   link: '',
    //   icon: <Dot size="small" color="secondary"/>
    // }
  ]
  var [structure, setStructure] = useState([])
  React.useEffect(() => {
      if (!!adminSectionType) {
        switch (adminSectionType) {
          case 'workspace':
            setStructure(workspaceStructure)
            break
          case 'subscription':
            setStructure(SubscriptionStructure)
            break
          default:
            break
        }
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [adminSectionType])

  var theme = useTheme()

  // global
  var { isSidebarOpened } = useLayoutState()
  var layoutDispatch = useLayoutDispatch()

  // local
  var [isPermanent, setPermanent] = useState(true)

  useEffect(function() {
    window.addEventListener('resize', handleWindowWidthChange)
    handleWindowWidthChange()
    return function cleanup () {
      window.removeEventListener('resize', handleWindowWidthChange)
    }
  })

  return (
    <Drawer
      variant={isPermanent ? 'permanent' : 'temporary'}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened
        })
      }}
      open={isSidebarOpened}
    >
      <div className={classes.toolbar}/>
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowForwardIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse)
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList}>
        {structure.map(link => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            isPermanent={isPermanent}
            {...link}
          />
        ))}
      </List>
    </Drawer>
  )

  // ##################################################################
  function handleWindowWidthChange () {
    var windowWidth = window.innerWidth
    var breakpointWidth = theme.breakpoints.values.md
    var isSmallScreen = windowWidth < breakpointWidth

    if (isSmallScreen && isPermanent) {
      setPermanent(false)
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true)
    }
  }
}

export default withRouter(Sidebar)
